<div>
  <app-icon [type]="state ? 'solid' : 'regular'" [icon]="state ? 'square-check' : 'square'"></app-icon>
  <ng-content></ng-content>
</div>
